export const JOB_STATUSES = {
  open: {
    name: 'open',
    displayName: 'new',
  },
  active: {
    name: 'active',
    displayName: 'active',
  },
  matched: {
    name: 'matched',
    displayName: 'matched',
  },
  in_progress: {
    name: 'in_progress',
    displayName: 'in progress',
  },
  completed: {
    name: 'completed',
    displayName: 'complete',
  },
  canceled: {
    name: 'canceled',
    displayName: 'canceled',
  },
  cancelled: {
    name: 'cancelled',
    displayName: 'canceled',
  },
  expired: {
    name: 'expired',
    displayName: 'expired',
  },
};

export const ACTIVE_JOBS = {
  statuses: ['open', 'in_progress', 'active', 'matched'],
};

export const COMPLETED_JOBS = {
  statuses: ['completed'],
};

export const UNFINISHED_JOBS = {
  statuses: ['canceled', 'cancelled', 'expired'],
};

export const PAST_JOBS = {
  statuses: [...COMPLETED_JOBS.statuses, ...UNFINISHED_JOBS.statuses],
};
